var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumChooser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.480469,
    y: 0.900757,
    width: 40,
    height: 37.5385,
    rx: 4,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8651 8.90076H13.0959C10.5482 8.90076 8.48047 10.9684 8.48047 13.5161V25.8238C8.48047 28.3715 10.5482 30.4392 13.0959 30.4392H27.8651C30.4128 30.4392 32.4805 28.3715 32.4805 25.8238V13.5161C32.4805 10.9684 30.4128 8.90076 27.8651 8.90076ZM17.7112 23.67V20.5931H23.2497V23.67H17.7112ZM23.2497 25.5161V28.5931H17.7112V25.5161H23.2497ZM23.2497 15.67V18.7469H17.7112V15.67H23.2497ZM30.6343 15.67V18.7469H25.0959V15.67H30.6343ZM15.8651 18.7469H10.3266V15.67H15.8651V18.7469ZM10.3266 20.5931H15.8651V23.67H10.3266V20.5931ZM25.0959 20.5931H30.6343V23.67H25.0959V20.5931ZM13.0959 10.7469H27.8651C29.3912 10.7469 30.6343 11.99 30.6343 13.5161V13.8238H10.3266V13.5161C10.3266 11.99 11.5697 10.7469 13.0959 10.7469ZM10.3266 25.8238V25.5161H15.8651V28.5931H13.0959C11.5697 28.5931 10.3266 27.35 10.3266 25.8238ZM27.8651 28.5931H25.0959V25.5161H30.6343V25.8238C30.6343 27.35 29.3912 28.5931 27.8651 28.5931Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumChooser);
export default __webpack_public_path__ + "static/media/columChooser.6417f241692e9f7f82a12869cdd4d530.svg";
export { ForwardRef as ReactComponent };